import React, { SVGProps } from 'react'

export type MailIconProps = SVGProps<SVGSVGElement>

const defaultArgs = {
    strokeWidth: 1.5,
    stroke: '#000000',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 18',
}

const MailIcon = ({ width = 29, height = 22, className, ...rest }: MailIconProps) => {
    return (
        <svg {...defaultArgs} width={width} height={height} className={className} {...rest}>
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M 21.75,3.7499999 V 14.25 c 0,1.372045 -0.523424,2.25 -2.25,2.25 H 4.5 C 2.8943357,16.5 2.25,15.826669 2.25,14.25 V 3.7499999 m 19.5,0 c 0,-1.4211711 -0.60587,-2.2500001 -2.25,-2.2500001 h -15 c -1.4830196,0 -2.25,0.6999878 -2.25,2.2500001 m 19.5,0 v 0.243 c 8.7e-5,0.781099 -0.404937,1.5063569 -1.07,1.916 L 13.18,10.524 c -1.18,0.581992 -1.18,0.605636 -2.36,0 L 3.32,5.9099999 C 2.6549374,5.5003568 2.2499134,4.7750989 2.25,3.9939999 v -0.244"
            />
        </svg>
    )
}

export default MailIcon

